import React, { useEffect, useState } from 'react'
import { getURL, postAPI } from '../../app/api';
import { store, setStore } from '../../app/store';

export default function Login() {
  const store_data = JSON.parse(store());
  const [IsBTNClicked, setIsBTNClicked] = useState(false);
  const [FormData, setFormData] = useState({
    action: 'Login'
  })
  const [PasswordVisibility, setPasswordVisibility] = useState(false)
  const [OrganizationData, setOrganizationData] = useState({});
  const [API_URL, setAPIURL] = useState("");


  const fetchURL = async () => {
    const URL = await getURL();
    setAPIURL(URL);
  };

  const handleChange = e => {
    const { name, value } = e?.target;
    setFormData({ ...FormData, [name]: value })
  }

  const makeLogin = async () => {
    try {
      const response = await postAPI("/users/loginByOTP", { ...FormData, user: store_data });
      console.log(response);
      if (response?.status == 1) {
        setIsBTNClicked(false);
        setStore({ ...response?.data, username: FormData?.username, is_login: 1, submit: FormData })
        window.location.href = '/Admin/Verification'
      } else {
        setIsBTNClicked(false);
        alert(response?.error)
      }
    } catch (e) {
      setIsBTNClicked(false);
      alert(e?.response?.data?.error)
      console.log("Exception Error: ", e?.response?.data?.error)
    }
  }

  const handleSubmitLogin = async () => {
    setIsBTNClicked(true);
    if (IsBTNClicked) {
    } else {
      const store_data = JSON.parse(store());
      if (store_data?.org_id && store_data?.username && !store_data?.role && store_data?.is_login == 1) {
        window.location.href = '/Admin/Verification'
      } else {
        makeLogin();
      }
    }
  }

  const fetchOrganizationData = async () => {
    try {
      const filter = { reg_domain: window?.location?.host }
      const response = await postAPI("/organization/fetchSingle", { ...filter, user: store_data });
      setOrganizationData({
        ...OrganizationData,
        ...response?.data[0]
      })
    } catch (e) {
      console.log("Exception Error: ", e?.response?.data?.error)
    }
  }

  useEffect(() => {
    fetchOrganizationData();
    fetchURL();
  }, [])
  return (
    <>
      <div class="authentication-wrapper authentication-cover authentication-bg container-fluid">
        <div class="authentication-inner row">
          <div class="d-none d-lg-flex col-lg-7 p-0">
            <div class="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center">
              <img src={"../../theme/assets/img/illustrations/auth-login-illustration-light.png"} alt="auth-login-cover" class="img-fluid my-5 auth-illustration" data-app-light-img="illustrations/auth-login-illustration-light.png" data-app-dark-img="illustrations/auth-login-illustration-dark.png" />

              <img src={"../../theme/assets/img/illustrations/bg-shape-image-light.png"} alt="auth-login-cover" class="platform-bg" data-app-light-img="illustrations/bg-shape-image-light.png" data-app-dark-img="illustrations/bg-shape-image-dark.png" />
            </div>
          </div>
          <div class="d-flex col-12 col-lg-5 align-items-center p-sm-5 p-4">
            <div class="w-px-400 mx-auto">
              <div class="app-brand mb-4">
                <a href="/Admin" class="app-brand-link gap-2">
                  <span class="app-brand-logo demo">
                    {/* <svg width="32" height="22" viewBox="0 0 32 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.00172773 0V6.85398C0.00172773 6.85398 -0.133178 9.01207 1.98092 10.8388L13.6912 21.9964L19.7809 21.9181L18.8042 9.88248L16.4951 7.17289L9.23799 0H0.00172773Z" fill="#7367F0"></path>
                    <path opacity="0.06" fill-rule="evenodd" clip-rule="evenodd" d="M7.69824 16.4364L12.5199 3.23696L16.5541 7.25596L7.69824 16.4364Z" fill="#161616"></path>
                    <path opacity="0.06" fill-rule="evenodd" clip-rule="evenodd" d="M8.07751 15.9175L13.9419 4.63989L16.5849 7.28475L8.07751 15.9175Z" fill="#161616"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.77295 16.3566L23.6563 0H32V6.88383C32 6.88383 31.8262 9.17836 30.6591 10.4057L19.7824 22H13.6938L7.77295 16.3566Z" fill="#7367F0"></path>
                  </svg> */}
                    <img src={`${API_URL}/${OrganizationData?.organization_logo}`} style={{ width: '100%' }} />
                  </span>
                </a>
              </div>
              <h3 class="mb-1 fw-bold">Welcome to Admin Panel! 👋</h3>
              <p class="mb-4">Please sign-in to your account and start the adventure.</p>

              <form id="formAuthentication" class="mb-3 fv-plugins-bootstrap5 fv-plugins-framework" method="POST" novalidate="novalidate">
                <div class="mb-3 fv-plugins-icon-container">
                  <label for="email" class="form-label">Email or Username</label>
                  <input type="text" class="form-control" id="email" name='username' onChange={handleChange} placeholder="Enter your email or username" autofocus="" />
                  <div class="fv-plugins-message-container invalid-feedback"></div></div>
                <div class="mb-3 form-password-toggle fv-plugins-icon-container">
                  <div class="d-flex justify-content-between">
                    <label class="form-label" for="password">Password</label>
                    <a href="/Admin/ForgetPassword">
                      <small>Forgot Password?</small>
                    </a>
                  </div>
                  <div class="input-group input-group-merge has-validation">
                    <input type={!PasswordVisibility ? "password" : "text"} id="password" class="form-control" name='password' onChange={handleChange} placeholder="············" aria-describedby="password" />
                    <span class="input-group-text cursor-pointer" onClick={() => setPasswordVisibility(!PasswordVisibility)}><i class="ti ti-eye-off"></i></span>
                  </div><div class="fv-plugins-message-container invalid-feedback"></div>
                </div>
                {/* <div class="mb-3">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="remember-me" />
                  <label class="form-check-label" for="remember-me"> Remember Me </label>
                </div>
              </div> */}
                <button type='button' class="btn btn-primary d-flex w-100 waves-effect waves-light" onClick={handleSubmitLogin}>{IsBTNClicked ? <> <i class="fas fa-circle-notch fa-spin"></i> &nbsp; &nbsp; </> : <></>} Sign in</button>
                <input type="hidden" />
              </form>
              {/* <p class="text-center">
              <span>New on our platform?</span>
              <a href="/Admin/Register">
                <span>Create an account</span>
              </a>
            </p> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
